module.exports = __webpack_public_path__ + "assets/img/kefu.9a00d570.png";